import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function LoginPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("lumis_user_token");
    if (token) navigate("/agenda", { replace: true });
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem("lumis_user_token", res.data.token);
      navigate("/agenda", { replace: true });
    } catch {
      setError("Email ou senha incorretos");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#EEF2FF] flex items-center justify-center p-6" data-testid="login-page">
      <div className="w-full max-w-sm lumis-fade">
        <div className="text-center mb-10 space-y-2">
          <div className="text-5xl text-[#1E3A8A] font-outfit font-light">✦</div>
          <h1 className="text-2xl font-outfit font-light text-gray-900">Entrar</h1>
          <p className="text-gray-500 text-sm font-manrope">Acesse sua conta Lumis</p>
        </div>

        <form onSubmit={handleLogin} className="space-y-4">
          <div>
            <label className="block text-gray-500 text-xs font-manrope mb-2 uppercase tracking-widest">Email</label>
            <input
              data-testid="login-email-input"
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              className="w-full bg-white text-gray-900 border border-gray-300 rounded-2xl px-5 py-3.5 focus:border-[#1E3A8A]/60 focus:ring-1 focus:ring-[#1E3A8A]/30 outline-none transition-all font-manrope text-sm"
            />
          </div>
          <div>
            <label className="block text-gray-500 text-xs font-manrope mb-2 uppercase tracking-widest">Senha</label>
            <input
              data-testid="login-password-input"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              className="w-full bg-white text-gray-900 border border-gray-300 rounded-2xl px-5 py-3.5 focus:border-[#1E3A8A]/60 focus:ring-1 focus:ring-[#1E3A8A]/30 outline-none transition-all font-manrope text-sm"
            />
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 rounded-2xl px-4 py-3 text-red-600 text-sm font-manrope" data-testid="login-error">
              {error}
            </div>
          )}

          <button
            data-testid="login-btn"
            type="submit"
            disabled={loading || !password}
            className="w-full bg-[#1E3A8A] text-white rounded-full px-8 py-4 font-manrope font-medium hover:bg-[#172554] active:scale-[0.98] transition-all disabled:opacity-40 shadow-[0_4px_14px_rgba(30,58,138,0.3)] mt-2"
          >
            {loading ? "Entrando..." : "Entrar"}
          </button>
        </form>

        <p className="text-center text-gray-500 text-sm font-manrope mt-6">
          Não tem conta?{" "}
          <Link to="/register" className="text-[#1E3A8A] hover:text-[#172554]" data-testid="login-register-link">
            Cadastre-se
          </Link>
        </p>
      </div>
    </div>
  );
}
